var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border" },
    [
      _c(
        "div",
        [
          _c("el-card", { attrs: { "body-style": "padding: 20px 0" } }, [
            _c("div", { staticClass: "main-title" }, [
              _vm._v("\n        Find Our Products In Local Stores\n      ")
            ]),
            _vm._v(" "),
            this.$data.localStoreList.length != 0
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "swiper-container" },
                    [
                      _c("div", {
                        staticClass:
                          "swiper-prev retailers-swiper-prev el-icon-arrow-left",
                        attrs: { slot: "button-prev" },
                        slot: "button-prev"
                      }),
                      _vm._v(" "),
                      _c(
                        "swiper",
                        {
                          staticStyle: { "margin-top": "40px" },
                          attrs: {
                            id: "swiper1",
                            options: _vm.localStoreSwiperOption
                          }
                        },
                        _vm._l(_vm.localStoreList, function(item, key) {
                          return _c("swiper-slide", { key: key }, [
                            _c("div", { staticClass: "card-detail" }, [
                              _c("div", { staticClass: "card-img" }, [
                                _c("img", {
                                  attrs: { src: item.img },
                                  on: {
                                    click: function($event) {
                                      return _vm.preImg(item, true)
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(_vm._s(item.storeName))
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "address-font",
                                  on: {
                                    click: function($event) {
                                      return _vm.preImg(item, false)
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-location-outline"
                                  }),
                                  _vm._v(_vm._s(item.storeAddress))
                                ]
                              )
                            ])
                          ])
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-next retailers-swiper-next el-icon-arrow-right",
                        attrs: { slot: "button-next" },
                        slot: "button-next"
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _vm._v("\n        Powered by ShopVidi\n      ")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "brand-details",
          attrs: {
            "show-close": true,
            visible: _vm.visible,
            "destroy-on-close": "",
            width: _vm.IS_MOBILE ? "100%" : "70%",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "vilocal-dialog" }, [
            _c("div", { staticClass: "describe" }, [
              _c("p", [_vm._v(_vm._s(_vm.curItm.storeName))]),
              _vm._v(" "),
              _c("div", [
                _c("i", { staticClass: "el-icon-location" }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.curItm.storeAddress))])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.curItm.description) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Powered by ShopVidi")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pre-img-content" }, [
              _c(
                "div",
                { staticClass: "pre-img-top" },
                [
                  _c("i", {
                    staticClass: "el-icon-arrow-left",
                    style: _vm.preOriginalIdx == 0 ? "opacity: 0.35" : "",
                    on: {
                      click: function($event) {
                        _vm.preOriginalIdx > 0
                          ? _vm.preOriginalIdx--
                          : _vm.preOriginalIdx
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("el-image", {
                    staticClass: "pre-original-img",
                    attrs: { src: _vm.preOriginalImg }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-arrow-right",
                    style:
                      _vm.curItm["imgList"] &&
                      _vm.preOriginalIdx == _vm.curItm["imgList"].length - 1
                        ? "opacity: 0.35"
                        : "",
                    on: {
                      click: function($event) {
                        ;(_vm.curItm["imgList"] &&
                          _vm.curItm["imgList"].length - 1) > _vm.preOriginalIdx
                          ? _vm.preOriginalIdx++
                          : _vm.preOriginalIdx
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pre-img-bottom" }, [
                _c("i", {
                  staticClass: "el-icon-arrow-left smail-img-swiper-prev",
                  style: _vm.preOriginalIdx == 0 ? "opacity: 0.35" : "",
                  attrs: { slot: "button-prev" },
                  slot: "button-prev"
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "small-img" },
                  [
                    _c(
                      "swiper",
                      {
                        ref: "swiper3",
                        staticClass: "swiper",
                        attrs: {
                          options: _vm.IS_MOBILE
                            ? _vm.smailStoreSwiperOptionMobile
                            : _vm.smailStoreSwiperOption
                        }
                      },
                      _vm._l(_vm.curItm["imgList"], function(item, key) {
                        return _c(
                          "swiper-slide",
                          { key: "swiperSlide" + key },
                          [
                            _c(
                              "div",
                              {
                                class: {
                                  "small-img-active": key == _vm.preOriginalIdx,
                                  "small-img-inactive":
                                    key !== _vm.preOriginalIdx
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clickSmailImg(item, key)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  key: "img" + key,
                                  class: {
                                    "small-img-width": _vm.getImgAbbr(item),
                                    "small-img-height": !_vm.getImgAbbr(item)
                                  },
                                  attrs: { src: item }
                                })
                              ]
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-arrow-right smail-img-swiper-next",
                  style:
                    _vm.curItm["imgList"] &&
                    _vm.preOriginalIdx == _vm.curItm["imgList"].length - 1
                      ? "opacity: 0.35"
                      : "",
                  attrs: { slot: "button-next" },
                  slot: "button-next"
                })
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cdf96310", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdf96310","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViLocal.vue
// module id = null
// module chunks = 